/**
 * Labels match the feature vector indices from features.ts:
 *  0: numNoteHashes, 1: numNullifiers, 2: numL2ToL1Msgs,
 *  3: numPrivateLogs, 4: numContractClassLogs, 5: numPublicLogs,
 *  6: gasLimitDa (DA mana limit), 7: gasLimitL2 (L2 mana limit), 8: maxFeePerDaGas (max fee/DA mana), 9: maxFeePerL2Gas (max fee/L2 mana),
 * 10: numSetupCalls, 11: numAppCalls, 12: totalPublicCalldataSize,
 * 13: expirationDelta, 14: feePayer
 */
export const FEATURE_LABELS = [
  "Notes",
  "Nullifiers",
  "L2→L1",
  "Priv Logs",
  "Class Logs",
  "Pub Logs",
  "DA Mana Limit",
  "L2 Mana Limit",
  "Max Fee/DA Mana",
  "Max Fee/L2 Mana",
  "Setup",
  "App",
  "Teardown",
  "Calldata Size",
  "Expiry",
  "Fee Payer",
];

export const GROUPS = [
  { start: 0, end: 5, label: "Counts" },
  { start: 6, end: 9, label: "Mana" },
  { start: 10, end: 13, label: "Pub Calls" },
  { start: 14, end: 14, label: "Time" },
  { start: 15, end: 15, label: "Identity" },
];

export const GROUP_GAP = 6;
export const PAD_X = 6;
export const PAD_TOP = 14;
export const PAD_BOT = 55;
export const ZERO_COLOR = "#555570";
export const EQUAL_COLOR = "#9999ff";
export const VB_W = 500;
export const VB_H_FULL = 200;
export const VB_H_COMPACT = 90;
